import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "messages",
  initialState: {
    list: [],
    adhocList: [],
    loading: false,
    lastFetch: null,
    addedMessage: false,
    addedNewMessage: { state: false, obj: null },
    addedAdhocMessage: false,
    msgReadStatus: false,
    emailMsgStatus: false,
    msgList: [],
    adhocMsgList: [],
    timerMsgList: [],
    msgDocSasUrls: null,
    msgPopupDocSasUrls: null,
  },
  reducers: {
    appMessagesReceived: (messages, action) => {
      messages.list = action.payload;
      messages.addedMessage = false;
      messages.msgReadStatus = false;
      messages.addedNewMessage = { state: false, obj: null };
    },
    appAdocMessagesReceived: (messages, action) => {
      messages.adhocList = action.payload;
    },
    appMessageAdded: (messages, action) => {
      const { sasUrls } = action?.payload || {};
      messages.addedMessage = true;
      messages.msgDocSasUrls = sasUrls;
    },
    appNewMessageAdded: (messages, action) => {
      const { sasUrls, msg } = action?.payload || {};
      messages.addedNewMessage = { state: true, obj: msg };
      messages.msgPopupDocSasUrls = sasUrls;
    },
    appAdhocMessageAdded: (messages, action) => {
      messages.addedAdhocMessage = true;
    },
    appMessageListRecevied: (messages, action) => {
      messages.msgList = action.payload;
      messages.msgReadStatus = false;
      messages.addedNewMessage = { state: false, obj: null };
    },
    updateMsgListRead: (messages, action) => {
      messages.msgReadStatus = action.payload;
    },
    appTimerMessageRecevied: (messages, action) => {
      messages.timerMsgList = action.payload;
    },
    sentMessageToEmailReceived: (messages, action) => {
      messages.emailMsgStatus = action.payload;
    },
  },
});

export const {
  appMessagesReceived,
  appMessageAdded,
  appAdocMessagesReceived,
  appMessageListRecevied,
  updateMsgListRead,
  appAdhocMessageAdded,
  appNewMessageAdded,
  appTimerMessageRecevied,
  sentMessageToEmailReceived,
} = slice.actions;
export default slice.reducer;

export const loadAppMessages = (id, userId) =>
  apiCallBegan({
    url: config.GetCommunication + id + "&perfId=" + userId,
    onSuccess: appMessagesReceived.type,
  });

export const loadAppAdhocMessages = (id) =>
  apiCallBegan({
    url: config.GetAdhocMessages + id,
    onSuccess: appAdocMessagesReceived.type,
  });

export const loadAppMsgList = (id) =>
  apiCallBegan({
    url: config.GetMessages + id,
    onSuccess: appMessageListRecevied.type,
  });

export const updateMessageRead = (id, userId) =>
  apiCallBegan({
    url: config.UpdateMessageReadStatus + id + "&perfId=" + userId,
    method: "patch",
    onSuccess: updateMsgListRead.type,
  });

export const addAppNewMessage = (data) =>
  apiCallBegan({
    url: config.AddNewMessage,
    method: "post",
    data: data,
    onSuccess: appMessageAdded.type,
  });

export const sendMessageThroughEmail = (data) =>
  apiCallBegan({
    url: config.SendMessageFromEmail,
    method: "post",
    data: data,
    onSuccess: sentMessageToEmailReceived.type,
  });

export const addAppMessage = (data) =>
  apiCallBegan({
    url: config.AddMessage,
    method: "post",
    data: data,
    onSuccess: appNewMessageAdded.type,
  });

export const addAppAdhocNewMessage = (data) =>
  apiCallBegan({
    url: config.AddAdocMessage,
    method: "post",
    data: data,
    onSuccess: appAdhocMessageAdded.type,
  });

export const loadAppTimerMessages = (id) =>
  apiCallBegan({
    url: config.GetTimerMessages + id,
    onSuccess: appTimerMessageRecevied.type,
  });

export const getAppMessages = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.list,
);

export const getAppAdhocMessages = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.adhocList,
);

export const getAddedMessageStatus = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.addedMessage,
);

export const getAddedNewMessageStatus = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.addedNewMessage,
);

export const getAppMsgList = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.msgList,
);

export const getAppMsgReadStatus = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.msgReadStatus,
);

export const getAppTimerMessages = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.timerMsgList,
);

export const getMsgDocSasUrls = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.msgDocSasUrls,
);

export const getMsgPopupDocSasUrls = createSelector(
  (state) => state.entities.messages,
  (messages) => messages.msgPopupDocSasUrls,
);
